import {GenericList} from './GenericList';
import {User} from '../../models/User';

export class UserList extends GenericList<User> {}
